import { useMeta } from "../../lib/api";

export default function LocationPicker({ district, taluka, place = "", onChange, withPlace = false, freePlace = false, required = false, allLabel = "संपूर्ण महाराष्ट्र · All Maharashtra", testPrefix = "location" }) {
  const meta = useMeta();
  const talukas = district && meta ? meta.talukas[district] || [] : [];
  const places = district && meta ? meta.places[district] || [] : [];
  const listId = `${testPrefix}-places`;
  return (
    <div className={`grid gap-3 ${withPlace ? "sm:grid-cols-3" : "sm:grid-cols-2"}`}>
      <select className="field" value={district} required={required} onChange={(e) => onChange(e.target.value, "", "")} data-testid={`${testPrefix}-district-select`}>
        <option value="">{required ? "जिल्हा निवडा · Select District *" : allLabel}</option>
        {meta?.districts.map((d) => <option key={d} value={d}>{d}</option>)}
      </select>
      <select className="field disabled:bg-slate-50 disabled:text-slate-400" value={taluka} required={required} disabled={!district} onChange={(e) => onChange(district, e.target.value, place)} data-testid={`${testPrefix}-taluka-select`}>
        <option value="">{required ? "तालुका निवडा · Select Taluka *" : "सर्व तालुके · All Talukas"}</option>
        {talukas.map((t) => <option key={t} value={t}>{t}</option>)}
      </select>
      {withPlace && freePlace && (
        <>
          <input className="field disabled:bg-slate-50" list={listId} maxLength={60} disabled={!district} value={place} onChange={(e) => onChange(district, taluka, e.target.value)} placeholder="गाव / शहर लिहा (optional)" data-testid={`${testPrefix}-place-input`} />
          <datalist id={listId}>{places.map((p) => <option key={p} value={p} />)}</datalist>
        </>
      )}
      {withPlace && !freePlace && (
        <select className="field disabled:bg-slate-50 disabled:text-slate-400" value={place} disabled={!district} onChange={(e) => onChange(district, taluka, e.target.value)} data-testid={`${testPrefix}-place-select`}>
          <option value="">सर्व गावे / शहरे</option>
          {places.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      )}
    </div>
  );
}
